import { HttpErrorResponse } from '@angular/common/http';
import { IValidation } from '../validation';
import { Observable } from 'rxjs';

export abstract class NibTravelHttpError {
  private internalHandled = false;

  constructor(public response?: HttpErrorResponse) {}

  get handled(): boolean {
    return this.internalHandled;
  }

  markAsHandled(): void {
    this.internalHandled = true;
  }
}

export class HttpNoConnectionError extends NibTravelHttpError {}

export class HttpNotFoundError extends NibTravelHttpError {}

export class HttpConflictError extends NibTravelHttpError {}

export class HttpUnprocessableEntityError extends NibTravelHttpError {
  constructor(response: HttpErrorResponse, public validation: IValidation) {
    super(response);
  }
}

export class HttpServerError extends NibTravelHttpError {}

export class HttpMiscellaneousError extends NibTravelHttpError {}

export class HttpPaymentThreeDSRequired extends NibTravelHttpError {
  public data: unknown;

  constructor(response: HttpErrorResponse) {
    super(response);
    this.data = response.error;
  }
}

export class HttpAlreadyPurchaseError extends NibTravelHttpError {}

export type ErrorObs = (err: any, caught: Observable<any>) => any;

export enum HttpErrorMessageCode {
  ServerError = 'ServerError',
  UserPassIncorrect = 'UserPassIncorrect',
  NoInternet = 'NoInternet',
  PurchaseError = 'PurchaseError',
  Timeout = 'Timeout',
  InvalidInputFallback = 'InvalidInputFallback',
  NotFound = 'NotFound',
  Declined = 'Declined',
  CardExpired = 'CardExpired',
  InsufficientFunds = 'InsufficientFunds',
  PaymentRequiredError = 'PaymentRequiredError',
  DepartureDateTooLow = 'DepartureDateTooLow',
  CampaignCodeInvalid = 'CampaignCodeInvalid',
  ResidentIdentifierInvalid = 'ResidentIdentifierInvalid',
  AlreadyPurchased = 'AlreadyPurchased',
  DuplicatePurchase = 'DuplicatePurchase',
}
